<template>
<div>

    <div>
      <HeaderAdmin/>
    </div>
    <div class="container shadows">
        <SingleMap/>
        <SensorForm/>
        
     
    </div>   
    </div>
</template>

<script>

// @ is an alias to /src
import HeaderAdmin from '@/components/HeaderAdmin.vue'
import SensorForm from '@/components/Sensor/SensorForm.vue'
import SingleMap from '@/components/Map/SingleMap.vue'



export default {
    name: 'SensorEdit',
      components: {
        HeaderAdmin, SensorForm, SingleMap
      },
    computed:{
      user(){
        return this.$store.getters.user
      },
    },
        mounted(){
        this.$store.dispatch('getApplication')
        // this.$store.dispatch('getDevice')
      }
  
}
</script>



<style >
.container{
  padding-top: 100px;
}
</style>
